import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "homePrenoBox"
}
const _hoisted_2 = { class: "mt-3 mb-3 d-flex justify-content-center align-items-center" }
const _hoisted_3 = { class: "ms-2 fw-bold" }
const _hoisted_4 = { class: "mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_exclamation = _resolveComponent("icon-exclamation")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_assenza_tre_giorni = _resolveComponent("assenza-tre-giorni")!

  return (_ctx.avviso)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(_component_icon_exclamation)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_localized_text, {
              localizedKey: "Avviso",
              text: "Avviso"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.avviso.type == 'AssenzaTreGiorni')
            ? (_openBlock(), _createBlock(_component_assenza_tre_giorni, {
                key: 0,
                notification: _ctx.avviso,
                onRead: _ctx.init
              }, null, 8, ["notification", "onRead"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}